import React, {useState, useRef, useEffect} from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "intersection-observer";
import Observer from "@researchgate/react-intersection-observer";
import PdfSubmission from "../PdfSubmission/PdfSubmission";

const ArticleSection = (props) => {
    const {
        autoAttached = true, //is it auto attached or a specific article?
        article = null, //either the reference article or the article to display depending on if it auto attached or not
        preview = false,
        order = "first" //which lazy loaded article on the page is it?
    } = props;

    const [loaded, setLoaded] = useState(false);
    const [sectionData, setSectionData] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const sectionRef = useRef(null);

    const fetchSection = (event) => {
        if(sectionRef.current != null && event.isIntersecting && loaded && !initialized) {
            refreshAds(sectionRef.current.querySelectorAll("[data-zone]"));

            // add article to url updater
            let article = sectionRef.current.querySelector("#ArticleView");
            let addChangeURLEvent = new CustomEvent("addChangeURL", { detail: article });

            window.dispatchEvent(addChangeURLEvent);
            setInitialized(true);
        }
    };

    const loadArticle = () => {
        let request = null;
        if(autoAttached) {
            request = axios.get("/api/article-section", {
                params: {
                    relatedTags: JSON.parse(article).tags.map(tag => tag.tagNo).join(","),
                    preview: JSON.stringify(preview),
                    order: order
                }
            });
        } else {
            request = axios.get(`/api/article-section/${article}`, {
                params: {
                    preview: preview
                }
            });
        }
        if(request) {
            request.then(response => {
                setSectionData(response.data.length ? response.data : null);
                setLoaded(true);

                if(sectionRef.current.parentNode && response.data.length) {
                    sectionRef.current.parentNode.classList.add("isLoaded");
                } else if (sectionRef.parentNode) {
                    sectionRef.current.parentNode.classList.add("isEmpty");
                }

            });
        }
    }

    useEffect(() => {
        if(!sectionData) {
            loadArticle();
        }
    })

    useEffect(() => {
        if(sectionData) {
            const title = sectionData.match(/data-title="[^"]*"/)[0].split(/["]/).slice(-2, -1)[0];
            const articleNo = parseInt(sectionData.match(/data-articleNo="\d+"/)[0].split(/["]/).slice(-2, -1)[0]);
            const articleDom = document.querySelector(`[data-articleno="${articleNo}"]`);
            const PdfSubmissionContainer = articleDom.querySelector("#PdfSubmissionContainer");
            if (PdfSubmissionContainer) {
                ReactDOM.hydrate(<PdfSubmission article={{articleNo, title}}/>, PdfSubmissionContainer);
            }
        }
    }, [sectionData])


    const refreshAds = (adSlots) => {
        let loadNewAdsEvent = new CustomEvent("loadNewAds", {detail: adSlots});

        window.dispatchEvent(loadNewAdsEvent);
    }

    const createMarkup = () => {
        return {
            __html: sectionData
        };
    }

    const sectionOptions = {
        onChange: fetchSection,
        rootMargin: "0% 0% 75%",
    };

    return (
        <div ref={sectionRef}>
            <Observer {...sectionOptions}>
                <div dangerouslySetInnerHTML={createMarkup()} />
            </Observer>
        </div>
    );
}

export default ArticleSection;
